"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      background = _ref.background,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "background", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledButtonGroup, _extends({
    background: background,
    className: className
  }, otherProps), children);
};

var StyledButtonGroup = _styledComponents.default.div.withConfig({
  displayName: "StyledButtonGroup"
})(["display:flex;width:100%;padding:0.8rem;background-color:#f0f1f3;border-radius:0.5rem;flex-flow:column;> *{margin-bottom:0.8rem;&:last-child{margin-bottom:0;}}"]);

ButtonGroup.propTypes = {
  children: _propTypes.node.isRequired,
  background: _propTypes.bool,
  className: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = ButtonGroup;
exports.default = _default;